// For HTML that is built as a string (v-html, dhtmlx templates, Tabulator formatters): escape text that customers
// or merchants typed so it can't add markup or scripts
export default function escapeHtml (value) {
  return String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}
